import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DS_DEMO_DNA2_5 = {
  title: `With the touch of AI innovation, the \nsystem <span style="color: #92D1FF;">automatically generates \ntransformation code</span> when provided with \nbusiness requirements, allowing Vignesh \nto review without manual coding. It's a \ntale of simplicity amid complexity.`,
  subtitle: "Data STREAMS demo",
  label: [{ iconPath: "start.png", text: "AI-first Innovation" }],
  next: {
    label: "CONTINUE",
    onClick: () => {
      setCurrentPage(210);
    },
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(108),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA2/DNA2_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "DNA2/DNA2_DS_DEMO_05_computer.png",
          imageStyle: {
            position: "absolute",
            right: "73.59px",
            bottom: "225.58px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_05_bubble_1.png",
          imageStyle: { position: "absolute", right: "176px", bottom: "503px" },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_05_bubble_2.png",
          imageStyle: {
            position: "absolute",
            right: "323px",
            bottom: "170px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_05_bubble_3.png",
          imageStyle: { position: "absolute", right: "735px", bottom: "461px" },
        },
      ]}
      pageNumber={209}
    />
  ),
};
